export const common = {
    prefix: {
        type: 'string',
        length: { minimum: 2, maximum: 255 },
        presence: { allowEmpty: false },
    },
    best_contact_time: {
        type: 'string',
        presence: { allowEmpty: false },
    },
    job_title: {
        type: 'string',
        length: { minimum: 2, maximum: 255 },
        presence: { allowEmpty: false },
    },
};
